import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class fenologicaService {

    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/fenologica`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}administracion/fenologica/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    
    async obtenerPorCultivoId(id) {
        const response = await axios
            .get(`${ERP}administracion/fenologica/por-cultivo/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}administracion/fenologica/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}administracion/fenologica/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}administracion/fenologica/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/

    async subirCargaMasiva(file) {
        const formData = new FormData();
        formData.append('file', file);
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };

        const response = await axios
            .post(`${ERP}administracion/fenologica/subir-carga-masiva`, formData, config)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


    async registrar(data) {
        const response = await axios
            .post(`${ERP}administracion/fenologica`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    
    async registrarCargaMasiva(data) {
        const response = await axios
            .put(`${ERP}administracion/fenologica/registrar-carga-masiva`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async formatoCargaMasiva() { 
        const response = await axios
            .get(`${ERP}administracion/fenologica/formato-carga-masiva`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}administracion/fenologica`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async eliminar(data) {
        const response = await axios
            .put(`${ERP}administracion/fenologica/eliminar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async activar(data) {
        const response = await axios
            .put(`${ERP}administracion/fenologica/activar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };
}

export default new fenologicaService();